import React, { Component } from 'react';
import { Login } from 'clorian-frontend-components';
import { connect } from 'react-redux';
import {loginVerifierUser} from '../login/api.actions';
import history from '../history';
import '../resources/stylesheets/login.css';
import clorianLogo from '../resources/images/Clorian.svg';
import {FormattedMessage} from "react-intl";

const USER_URL = process.env.REACT_APP_USER_SERVICE_URL;

class LoginContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      hideText: true
    };
    this.handlerLogin = this.handlerLogin.bind(this);
    this.hideText = this.hideText.bind(this)
  }

  hideText() {
    this.setState({
      hideText: true,
    })
  }

  handlerLogin(creds) {
    this.setState({
      disabled: true
    });

    const { dispatch } = this.props;
    dispatch(loginVerifierUser(creds))
      .then(response => {
        if (response && response.isAuthenticated) {
          setTimeout(() => {
            history.push('/home/clients');
          }, 1500);
        } else {
          this.setState({
            disabled: false,
            error: response
          });
        }
      })
      .catch(function(e) {
        this.setState({
          disabled: false,
          error: e.message
        });
        console.log(e.message);
      });
  }

  render() {
    const { disabled, error } = this.state;
    const textMessages = {
      resetPassword: {
        emailLabel: <FormattedMessage id={'login.user.username'} defaultMessage={'Username'} />,
        sendResetLabel: <FormattedMessage id={'login.send.label'} defaultMessage={'Send'} />,
        newPasswordLabel: <FormattedMessage id={'login.password.label'} defaultMessage={'Password'} />,
        repeatPasswordLabel: (<FormattedMessage id={'login.repeatnewpassword.label'} defaultMessage={'Confirm password'} />),
        changePasswordLabel: <FormattedMessage id={'login.createpassword.label'} defaultMessage={'Change password'} />,
        backLoginLabel: <FormattedMessage id={'login.back.label'} defaultMessage={'Back to login'} />,
        validationErrorFormat:<FormattedMessage id={'login.error.password.validation.format'} defaultMessage={'Length between 8 and 16,presence of at least one capital letter, one lower case letter, one digit and one special character in (#?!@$%^&*-.).'}/>,
        validationErrorMatch: <FormattedMessage id={'login.error.password.validation.match'} defaultMessage={'Passwords do not match'}/>
      },
      notifications: {
        passwordChanged: (<FormattedMessage id={'login.successpasswordchanged.notification'} defaultMessage={'Password changed successfully'}/>),
        emailSent: <FormattedMessage id={'login.emailsent.notification'} defaultMessage={'Email sent'} />
      }
    };

    return (
        <div className={`container  login_page`}>
          <div className="login-wrap">
            <Login
              onSubmit={this.handlerLogin}
              logo={clorianLogo}
              disabled={disabled}
              error={error}
              userService={USER_URL}
              module={'affiliate'}
              hideText={this.hideText}
              textMessages={textMessages}
            />
          </div>
        </div>
    );
  }
}

export default connect()(LoginContainer);
